module.exports = require('./PageButton');


/** WEBPACK FOOTER **
 ** ./demo/src/pages/button/index.js
 **/